import { render } from "./LabReception.vue?vue&type=template&id=4e59c19a&scoped=true"
import script from "./LabReception.vue?vue&type=script&lang=js"
export * from "./LabReception.vue?vue&type=script&lang=js"

import "./LabReception.vue?vue&type=style&index=0&id=4e59c19a&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e59c19a"]])

export default __exports__